import ChartTemplate from "@/components/chart-template";
import { RevenueRow } from "@/http/api-types";
import { calculateSecondaryCPAAchievement } from "../performance-calculations";
import CPIAchievementChart from "./secondary-cpa-chart";

type ChartRow = RevenueRow & {
  dateTime: string;
};

export type ChartData = ChartRow[];

export const revenuePercentagePerRow = (revenue: number, maxRevenue: number) =>
  Math.round((revenue / maxRevenue) * 100);

type CPIChartProps = {
  data: RevenueRow[];
};

function SecondaryCPAAchievement({ data }: CPIChartProps) {
  const chartData: ChartData = data.map(row => ({
    ...row,
    dateTime: row.bid_day.slice(0, 10),
  }));

  const secondaryCpaAchievement = calculateSecondaryCPAAchievement(data);

  return (
    <ChartTemplate
      chart={<CPIAchievementChart chartData={chartData} />}
      table={null}
      title="CPA Achievement"
      description="Revenue over 2nd AP Conversions"
      summaryMetric={secondaryCpaAchievement.toLocaleString("en-US", {
        style: "percent",
      })}
      summaryMetricLabel="CPA Achievement"
      timeSplittable={false}
    />
  );
}

export default SecondaryCPAAchievement;
